module.exports = __webpack_public_path__ + "static/unique-online-store@3x-270958270e82254c42c562dc527f4555.png";